import FormattedMessage from 'I18n/components/FormattedMessage';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { useTheme } from 'foundations-theming/utils';
import Heading from './Heading';
import { useCreatePlaylistModalPath } from '../../features/savedItems';
import UsageTracker from '../../utils/UsageTracker';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SavedItemsHeader = () => {
  const {
    isMobile
  } = useMediaQuery();
  const theme = useTheme();
  const createPlaylistModalPath = useCreatePlaylistModalPath();
  const onCreatePlaylistClick = () => {
    UsageTracker.track('playlistInteraction', {
      action: 'create-playlist',
      location: 'playlist-page-header'
    });
  };
  return /*#__PURE__*/_jsx(Heading, {
    rightContent: /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "end",
      children: [!isMobile && /*#__PURE__*/_jsx(View, {
        blockSize: theme.space['250'],
        flex: 1,
        inlineSize: "100%",
        maxInlineSize: "100px"
      }), /*#__PURE__*/_jsx(RouterButton, {
        marginBlock: isMobile ? '300' : undefined,
        onClick: onCreatePlaylistClick,
        to: createPlaylistModalPath,
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.savedItems.createPlaylist"
        })
      }), !isMobile && /*#__PURE__*/_jsx(View, {
        blockSize: theme.space['250'],
        flex: 1,
        inlineSize: "100%",
        maxInlineSize: "100px"
      })]
    }),
    subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.heading.headingSubTitles.MY_PLAYLISTS"
    }),
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.heading.headingTitles.MY_PLAYLISTS"
    })
  });
};
const SavedItemsLayout = ({
  children
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SavedItemsHeader, {}), children]
  });
};
export default SavedItemsLayout;